import { render, staticRenderFns } from "./maintanance.vue?vue&type=template&id=bd4dd32a&"
import script from "./maintanance.vue?vue&type=script&lang=js&"
export * from "./maintanance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports